export default __webpack_public_path__ + "static/media/carbon-logo-white.7734980c.svg";